module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": ("" + (_vm.state.color))
    }
  }, [_vm._v("Статус: "), _c('strong', [_vm._v(_vm._s(_vm.state.stateName))])]), _c('div', {
    staticClass: "feedback__body"
  }, [_c('AppPicture', {
    staticClass: "feedback__pic",
    attrs: {
      "alt": _vm.vacancyName,
      "image": _vm.partnerLogo
    }
  }), _c('div', {
    staticClass: "feedback__block"
  }, [(_vm.vacancyName) ? _c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v(_vm._s(_vm.vacancyName))]) : _vm._e(), (_vm.state && _vm.state.message) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v(_vm._s(_vm.state.message))]) : _vm._e(), (_vm.dateСreated) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Дата отклика: "), _c('strong', [_vm._v(_vm._s(_vm.dateСreated))])]) : _vm._e(), (_vm.partnerName) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Организация: "), _c('strong', [_vm._v(_vm._s(_vm.partnerName))])]) : _vm._e(), (_vm.state.stateId === 'invitation') ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Дата приглашения на работу: "), _c('strong', [_vm._v(_vm._s(_vm.state.stateDate))])]) : _vm._e()], 1), (_vm.userCanCancel && !_vm.state.refusal) ? _c('Cancellation', {
    staticClass: "no-bottom",
    on: {
      "cancel": _vm.cancelVacancy
    }
  }) : _vm._e(), _c('router-link', {
    staticClass: "feedback__link",
    attrs: {
      "to": _vm.linkToVacancy
    }
  }, [_vm._v("Открыть страницу вакансии")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-965eff1c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/FeedbackCard/FeedbackCard.vue
// module id = ffba5fc6088f611cb8ed
// module chunks = 89